import React, { forwardRef, useMemo } from 'react';
import { StyledModal } from "@constants/Themed";
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import apis from '@api/api';

const AddCallFlowModal = forwardRef((props, ref) => {

  const callFlowSchema = useMemo(() => ({
    'title': { type: 'string' },
    'description': { type: 'string' },
    'type': { type: 'dropDown', content: { enum: ['inbound', 'outbound', 'ivr'] } },
  }), []);

  return (
    <StyledModal
      title='Add Call Flow'
      caption='Create a new call flow'
      ref={ref}>
      <GenerateSchemaForm buttonIcon={"right"} submitFunction={async (v) => {
        console.log(v, 'sending vals');
        await apis.createCallFlow(v);
      }} buttonLabel='Create Flow' customStyling={{ minHeight: 400, paddingRight: 20 }} schema={callFlowSchema} />
    </StyledModal>
  )
})
export default AddCallFlowModal;